/**
 * Svelte action: report a broken image.
 *
 * Calls `onBroken` when the image fails to load. Unlike a bare `on:error`
 * listener, this also catches failures that happen before hydration
 * (server-rendered images whose error event fired before listeners attached)
 * by inspecting `complete`/`naturalWidth` on mount.
 *
 * @param {HTMLImageElement} node
 * @param {() => void} onBroken
 * @returns {{destroy: () => void}}
 */
export function detectBrokenImage(node, onBroken) {
	const check = () => {
		if (node.complete && node.naturalWidth === 0) onBroken();
	};
	node.addEventListener('error', check);
	check();
	return {
		destroy() {
			node.removeEventListener('error', check);
		}
	};
}
